import React from 'react'
import LocationsMainPage from './components/LocationsMainPage'

const Locations = () => {
  return (
    <LocationsMainPage/>
  )
}

export default Locations